import { useState, useEffect, useCallback } from "react";

export interface NominatimResult {
  place_id: number;
  display_name: string;
  name?: string;
  lat: string;
  lon: string;
  address?: {
    road?: string;
    state?: string;
    country?: string;
    city?: string;
  };
}

function useNominatimGeocoding(query: string) {
  const [results, setResults] = useState<NominatimResult[]>([]);
  const [loading, setLoading] = useState(false);

  const countryCodes = "AE";
  const viewbox = "51.5795186705,22.4969475367,56.3968473651,26.055464179";

  const fetchLocations = useCallback(async () => {
    if (!query) {
      setResults([]);
      return;
    }

    setLoading(true);

    try {
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
        query,
      )}&countrycodes=${countryCodes}&addressdetails=1&limit=30&dedupe=0&viewbox=${viewbox}&bounded=1&accept-language=en`;

      const res = await fetch(url);
      const data: NominatimResult[] = await res.json();

      setResults(data);
    } catch (error) {
      console.error("Error fetching Nominatim:", error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  }, [query]);

  useEffect(() => {
    fetchLocations();
  }, [fetchLocations]);

  return { results, loading };
}

export default useNominatimGeocoding;
